module.exports = __webpack_public_path__ + "static/mailjetImage-54ae9921c2af7ab817c71193810e37b0.png";